import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NotificationType } from 'app/types/types'
import { t } from 'i18next'
import React from 'react'

export interface AlertState {
  id: string
  title: string
  description: string | React.ReactNode
  type: NotificationType
  deactivateCloseButton?: boolean
  onClose?: () => void
  onSecondaryClick?: () => void
  secondaryButtonContent?: string | React.ReactNode
  onPrimaryClick?: () => void
  primaryButtonContent?: string | React.ReactNode
  isVisible?: boolean
  isLoadingPrimaryButton?: boolean
  isDismissOnBackdrop?: boolean
  isWaitForAction?: boolean
}

const initialState: AlertState = {
  id: '',
  title: '',
  description: '',
  type: 'info',
  onClose: undefined,
  onSecondaryClick: undefined,
  secondaryButtonContent: t('errors.modalCancel'),
  onPrimaryClick: undefined,
  primaryButtonContent: t('errors.modalOK'),
  isVisible: false,
  isLoadingPrimaryButton: false,
  isDismissOnBackdrop: false,
  isWaitForAction: false
}

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    showAlert: (state, action: PayloadAction<AlertState>) => {
      const {
        id,
        title,
        description,
        type,
        onClose,
        onSecondaryClick,
        onPrimaryClick,
        isLoadingPrimaryButton,
        isDismissOnBackdrop,
        isWaitForAction,
        secondaryButtonContent,
        primaryButtonContent,
        deactivateCloseButton
      } = action.payload

      state.id = id
      state.title = title
      state.description = description
      state.type = type
      state.isVisible = true

      state.onClose = onClose ? onClose : undefined
      state.onSecondaryClick = onSecondaryClick ? onSecondaryClick : undefined
      state.secondaryButtonContent = secondaryButtonContent ? secondaryButtonContent : t('errors.modalCancel')
      state.onPrimaryClick = onPrimaryClick ? onPrimaryClick : undefined
      state.primaryButtonContent = primaryButtonContent ? primaryButtonContent : t('errors.modalOK')

      state.isLoadingPrimaryButton = isLoadingPrimaryButton ? isLoadingPrimaryButton : false
      state.isDismissOnBackdrop = isDismissOnBackdrop ? isDismissOnBackdrop : false
      state.deactivateCloseButton = deactivateCloseButton ? deactivateCloseButton : false
      state.isWaitForAction = isWaitForAction ? isWaitForAction : false
    },
    hideAlert: state => {
      state.isVisible = false
    },
    updateIsLoadingState: (state, action: PayloadAction<boolean>) => {
      state.isLoadingPrimaryButton = action.payload
    }
  }
})

export const { showAlert, hideAlert, updateIsLoadingState } = alertSlice.actions

export default alertSlice.reducer
